<template>
    <el-select :size="size"
               :value="value"
               :filterable="filterable"
               :disabled="disabled"
               :clearable="clearable"
               @change="change($event)"
               :class="clazz">
        <el-option v-for="item in assetAttributes"
                   :label="item.assetattrid + '-' + item.description"
                   :value="item.assetattributeid"
                   :key="item.assetattributeid"></el-option>
    </el-select>
</template>

<script>
    import {AssetServer} from "@/api";

    export default {
        name: "asset-attribute-select",

        props: {
            value: {
                type: String,
            },
            clazz: {
                type: String,
                default: 'width70',
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            filterable: {
                type: Boolean,
                default: true,
            },
            clearable: {
                type: Boolean,
                default: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            size: {
                type: String,
                default: 'small',
            }
        },

        data() {
            return {
                assetAttributes: [],
            }
        },

        mounted() {
            this.queryAssetAttributeList();
        },

        methods: {
            queryAssetAttributeList() {
                AssetServer.assetAttribute.all({}).then(res => {
                    if (res.data.code === 200) {
                        for (let i = 0; i < res.data.data.length; i++) {
                            res.data.data[i].assetattributeid = res.data.data[i].assetattributeid + '';
                        }
                        this.assetAttributes = res.data.data;
                        this.$emit('fetchAllAssetAttributes', this.assetAttributes);
                    }
                });
            },

            change: function (key) {
                this.$emit('input', key);
            },
        },

    }
</script>

<style scoped>

</style>